module.exports = __webpack_public_path__ + "static/media/reshot-icon-sun-cloud-Z68ADE74PR.738e056b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reshot-icon-sun-cloud-Z68ADE74PR.svg
// module id = 241
// module chunks = 0